'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import UsageTracker from './utils/UsageTracker';
import { postLessonEngagment, postTrackEngagment } from './api/ConversionEventApi';
const ENGAGEMENT_MINUTES = 8;
export default class EngagementTracking extends PureComponent {
  constructor(...args) {
    super(...args);
    this.engagementDuration = 0;
    this.userEngaged = () => {
      clearInterval(this.interval);
      this.engamentStartTime = new Date().getTime();
      this.interval = setInterval(this.checkEngagement, 30000);
    };
    this.userUnengaged = () => {
      clearInterval(this.interval);
      this.checkEngagement();
    };
    this.checkEngagement = () => {
      this.engagementDuration += new Date().getTime() - this.engamentStartTime;
      this.engamentStartTime = new Date().getTime();
      const engagementMinutes = (new Date().getTime() - this.engamentStartTime + this.engagementDuration) / 1000 / 60;
      this.maybeSubmitForm(engagementMinutes);
    };
    this.startTracking = () => {
      this.userEngaged();
      window.addEventListener('blur', this.userUnengaged);
      window.addEventListener('focus', this.userEngaged);
    };
    this.stopTracking = () => {
      clearInterval(this.interval);
      window.removeEventListener('blur', this.userUnengaged);
      window.removeEventListener('focus', this.userEngaged);
    };
    this.maybeSubmitForm = engagementMinutes => {
      if (engagementMinutes > ENGAGEMENT_MINUTES) {
        this.stopTracking();
        const {
          match: {
            params
          }
        } = this.props;
        if (params.lessonId) {
          postLessonEngagment(params.lessonId);
          UsageTracker.track('interaction', {
            action: 'lesson-engagement-timer',
            minutes: ENGAGEMENT_MINUTES,
            lessonId: params.lessonId
          });
        }
        if (params.trackId) {
          postTrackEngagment(params.trackId);
          UsageTracker.track('interaction', {
            action: 'track-engagement-timer',
            minutes: ENGAGEMENT_MINUTES,
            trackId: params.trackId
          });
        }
      }
    };
  }
  componentDidMount() {
    this.startTracking();
  }
  componentWillUnmount() {
    this.userUnengaged();
    this.stopTracking();
  }
  render() {
    return null;
  }
}
EngagementTracking.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      lessonId: PropTypes.string,
      trackId: PropTypes.string
    }).isRequired
  }).isRequired
};